
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";

const COLORS = ["#0d6efd", "#1cc88a", "#ffc107", "#dc3545", "#6c757d"];

const MembretesPorEstadoChart = ({ membretes = [] }) => {
     const yearActual = new Date().getFullYear();

  const membretesFiltrados = membretes.filter((m) => {
    const fecha = new Date(m.fecha);
    return fecha.getFullYear() === yearActual;
  });
  return (
    <div className="card text-center shadow-sm p-3 mb-3">
      <h6>Membretes por Estado</h6>
      <ResponsiveContainer width="100%" height={180}>
        <PieChart>
          <Pie
            data={membretesFiltrados}
            dataKey="total"
            nameKey="estado"
            cx="50%"
            cy="50%"
            outerRadius={80}
            label
          >
            {membretes.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>

      {/* Leyenda horizontal */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "15px",
          marginTop: "10px",
        }}
      >
        {membretes.map((entry, index) => (
          <div
            key={index}
            style={{ display: "flex", alignItems: "center", gap: "5px" }}
          >
            <div
              style={{
                width: "15px",
                height: "15px",
                backgroundColor: COLORS[index % COLORS.length],
                borderRadius: "3px",
              }}
            ></div>
            <span style={{ fontSize: "0.9rem" }}>{entry.estado}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MembretesPorEstadoChart;
